import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../context/AuthContext';
import { API } from '../utils/helpers';

export default function LoginPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const refCode = searchParams.get('ref');

  useEffect(() => {
    if (user) {
      if (refCode) {
        fetch(`${API}/referral/apply`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ referral_code: refCode })
        }).finally(() => navigate('/dashboard'));
      } else {
        navigate('/dashboard');
      }
    }
  }, [user, navigate, refCode]);

  const handleGoogleLogin = () => {
    if (refCode) sessionStorage.setItem('pending_referral', refCode);
    window.location.href = `${API}/auth/google/login`;
  };

  return (
    <div className="mystic-bg min-h-screen flex flex-col items-center justify-center relative overflow-hidden">
      <div className="stars">
        {[...Array(60)].map((_, i) => (
          <div key={i} className="star" style={{ width: Math.random() * 2 + 1 + 'px', height: Math.random() * 2 + 1 + 'px', left: Math.random() * 100 + '%', top: Math.random() * 100 + '%', animationDelay: Math.random() * 3 + 's' }} />
        ))}
      </div>
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full opacity-15" style={{ background: 'radial-gradient(circle, rgba(108,92,231,0.3) 0%, transparent 70%)' }} />
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="relative z-10 flex flex-col items-center px-6 max-w-md w-full">
        <motion.img src="https://customer-assets.emergentagent.com/job_mystic-cards-56/artifacts/wfhpmaw5_Madame-Blavatsky--Logo-2_20260216_193202_0000.png" alt="Madame Blavatsky" className="w-32 h-32 mb-6" initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: 0.6, delay: 0.2 }} />
        <h1 className="font-decorative text-3xl sm:text-4xl text-gold-300 mb-2 text-center" data-testid="login-title">Madame Blavatsky</h1>
        <p className="text-[var(--text-muted)] italic text-sm mb-8 text-center font-heading tracking-wide">"La verdad se revela a quienes la buscan"</p>
        <motion.div className="w-full glass-card rounded-2xl p-8" style={{ borderColor: 'rgba(230,195,106,0.12)' }} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.4 }}>
          <p className="text-center text-[var(--text-muted)] text-sm mb-6">Inicia sesion para acceder a tus lecturas, historial y creditos</p>
          <button onClick={handleGoogleLogin} className="w-full flex items-center justify-center gap-3 bg-white hover:bg-gray-100 text-gray-800 font-medium py-3 px-6 rounded-xl transition-all duration-200 hover:shadow-lg hover:shadow-purple-500/10" data-testid="google-login-btn">
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Continuar con Google
          </button>
        </motion.div>
        <p className="text-purple-500/40 text-xs mt-8 text-center">Tarot, Astrologia y Numerologia</p>
        <button onClick={() => navigate('/')} className="mt-4 text-purple-400/60 hover:text-purple-300 text-sm transition-colors" data-testid="login-back-btn">Volver al inicio</button>
      </motion.div>
    </div>
  );
}
